import { EventType } from "@/analytics/analytics-events";
import { ToolName } from "@/store/ui/ui-slice";
import {
  FaroTooltip,
  FullScreenIcon,
  ToolButton,
  ToolGroup,
  Toolbar,
} from "@faro-lotv/flat-ui";
import { Analytics } from "@faro-lotv/foreign-observers";
import { useState, type JSX } from "react";
import { DataPreparationToolsToolbar } from "../data-praparation-tools-toolbar";
import { DataPreparationViewSettingsTool } from "./data-preparation-view-settings-tool";

interface DataPreparationViewSettingsToolbarProps {
  /** Callback executed when the view is reset */
  onFocusOnProject(): void;
  /** The currently active tool */
  activeTool: ToolName | undefined;
  /** Callback to toggle the active tool */
  toggleTool(tool: ToolName): void;
}

/** @returns a toolbar that contains the tools to manage view settings in the data preparation tool */
export function DataPreparationViewSettingsToolbar({
  onFocusOnProject,
  activeTool,
  toggleTool,
}: DataPreparationViewSettingsToolbarProps): JSX.Element | null {
  const [toolbarRef, setToolbarRef] = useState<HTMLDivElement | null>(null);

  return (
    <Toolbar
      ref={setToolbarRef}
      sx={{ alignSelf: "flex-end", overflow: "visible" }}
    >
      <ToolGroup>
        <DataPreparationViewSettingsTool anchorEl={toolbarRef} />

        <FocusOnProjectTool onFocusOnProject={onFocusOnProject} />

        <DataPreparationToolsToolbar
          activeTool={activeTool}
          onToggleTool={toggleTool}
        />
      </ToolGroup>
    </Toolbar>
  );
}

type FocusOnProjectToolProps = Pick<
  DataPreparationViewSettingsToolbarProps,
  "onFocusOnProject"
>;

/** @returns tool button to trigger focus on the whole project */
function FocusOnProjectTool({
  onFocusOnProject,
}: FocusOnProjectToolProps): JSX.Element {
  return (
    <FaroTooltip title="Focus on project" placement="left">
      <ToolButton
        aria-label="focus on project"
        onClick={(e) => {
          Analytics.track(EventType.recenterRegistrationView);
          e.nativeEvent.stopImmediatePropagation();
          onFocusOnProject();
        }}
      >
        <FullScreenIcon />
      </ToolButton>
    </FaroTooltip>
  );
}
